// extracted by mini-css-extract-plugin
export default {"image":"w0-z","loaded":"x0-z"};